<template>
  <div class="messages-list">
    <div v-if="!isLoggedIn">
      <p>Please log in to use messages</p>
    </div>
    <div class="notificaitons-wrap">
      <a href="#">Enable Desktop Notifications <i class="fal fa-bell"></i></a>
    </div>
    <div id="inbox-container"></div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  /* global Talk */
  export default {
    name: 'MessagesList',
    data () {
      return {
        isLoggedIn: false
      }
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.isLoggedIn = true
        }
      })
      this.$eventHub.$on('user-username-set', function (id, name) {
        vm.initMessaging(false, '', '', false)
      })
      this.$eventHub.$on('message-user', function (id, name) {
        console.log(id)
        vm.initMessaging(true, id, name, false)
      })
      this.$eventHub.$on('message-group', function (group) {
        console.log('message-group')
        vm.initMessaging(true, '', false, group)
      })
    },
    beforeDestroy () {
      this.$eventHub.$off('user-username-set')
      this.$eventHub.$off('message-user')
      this.$eventHub.$off('message-group')
    },
    methods: {
      initMessaging: function (isConversation, userID, username, group) {
        console.log('initMessaging')
        let vm = this
        Talk.ready.then(function () {
          console.log('talk ready isconvo: ' + isConversation + ', userID: ' + userID)
          var me = new Talk.User({
            id: vm.$globals.userId,
            name: vm.$globals.userUsername,
            email: vm.$globals.userEmail,
            // photoUrl: vm.$globals.userPhoto,
            configuration: "default"
          })
          var talkSession = new Talk.Session({
            appId: 'tymQ2mLE',
            me: me
          })
          if (isConversation && !group) {
            console.log('conversation mode')
            var other = new Talk.User({
              id: userID,
              name: username,
              configuration: "default"
            })

            var conversation = talkSession.getOrStartConversation(other)
            var convoInbox = talkSession.createInbox({selected: conversation})
            convoInbox.mount(document.getElementById('inbox-container'))
          } else if (isConversation && group) {
            console.log('conversation group mode')
            var conversation = talkSession.getOrCreateConversation(group.id)
            conversation.setParticipant(me);
            console.log(group.members)
            for (var participant in group.members) {
              var obj = group.members[participant]
              var talkMember = new Talk.User({
                  id: obj.id,
                  name: obj.username,
                  configuration: "default"
              });
              console.log(talkMember)
              conversation.setParticipant(talkMember);
            }
            
            conversation.setAttributes({
                subject: decodeURIComponent(group.name)
            })

            var convoInbox = talkSession.createChatbox(conversation);    
            convoInbox.mount(document.getElementById('inbox-container'))
          } else {
            console.log('inbox mode')
            var inbox = talkSession.createInbox({
              showFeedHeader: true
            })
            inbox.mount(document.getElementById('inbox-container')).then( (value) => {
              console.log('inbox mount value: ' + value)
              if (!localStorage.grapevineDesktopNotifications) {
                talkSession.setDesktopNotificationEnabled(true)
                localStorage.setItem('grapevineDesktopNotifications', true);
              }
            })
            talkSession.unreads.on('change', function (conversationIds) {
              var unreadCount = conversationIds.length
              console.log('unreadCount: ' + unreadCount)
              if (unreadCount > 0) {
                document.getElementById('unread-message-count').classList.add('hasUnread')
              } else {
                document.getElementById('unread-message-count').classList.remove('hasUnread')
              }
              console.log('Conversation IDs', conversationIds)
            })
          }
        })
      }
    },
    mounted: function () {
    }
  };
</script>

<style>
  #inbox-container iframe {
    height: calc(100vh - 150px)!important;
  }
  @media only screen and (max-width: 767px) {
    #inbox-container iframe {
      min-height: 0!important;
      height: 60%!important;
      height: 60vh!important;
      height: calc(100vh - 200px)!important;
    }
  }
</style>
<style scoped>
  #inbox-container {
    width: 100%;
    min-height: 300px;
    height: auto;
    overflow: hidden;
  }
  #inbox-container > iframe {
    min-height: 300px;
  }
  .notificaitons-wrap {
    margin-bottom: 20px;
    display: none;
  }
  .notificaitons-wrap > a {
    text-decoration: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/MessagesList.vue